import React from 'react';
import { useLazyQuery } from '@apollo/client';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { convertArrayToCSV } from 'convert-array-to-csv';
import GET_ALL_ACTIVE_USERS from '../../queries/getAllActiveUsersQuery';
import _ from 'lodash';
import { DIRECT_CHANNEL_OPTIONS } from '../../../AppraiserForm/constants/directChannelOptions';
import { OBSERVATION_OPTIONS } from '../../../AppraiserForm/constants/observationOptions';
import * as SYSTEM_ROLES from '../../../../constants/system-roles';
import SUPPLEMENTAL_ROLES from '../../../../constants/supplemental-Roles';

const FILE_NAME = 'VIP_Portal_Users';

const INTERNAL_ROLES = [
  SYSTEM_ROLES.ORG_COORDINATOR,
  SYSTEM_ROLES.ORG_SPONSOR,
  SYSTEM_ROLES.ORG_UNIT_COORDINATOR,
  SYSTEM_ROLES.ORG_UNIT_SPONSOR,
  SYSTEM_ROLES.INTERNAL_ATM
];
const FDA_ATM_ROLES = [SYSTEM_ROLES.FDA_ADMIN, SYSTEM_ROLES.FDA_REVIEWER];
const STAFF_ATM_ROLES = [SYSTEM_ROLES.VIP_PORTAL_ADMIN];

const UserListDownloader = () => {
  const [getAllUsers] = useLazyQuery(GET_ALL_ACTIVE_USERS);

  const handleDownload = async e => {
    e.preventDefault();
    const { data } = await getAllUsers();

    if (!data) {
      return;
    }

    const sortedUserList = _.sortBy(data.allActiveUsers, [
      user => user.UserLicense.LicensedOrg,
      user => user.UserLicense.LicensedOrgUnit,
      user => user.UserLicense.SystemRole.DisplayName,
      user => user.UserLicense.SupplementalRoleId
    ]);

    const formattedUserList = sortedUserList.map(appraiserUser => {
      const user = appraiserUser.UserLicense;
      const appraiserInfo = appraiserUser.AppraiserInfo || {};

      return {
        Email: user.Email,
        Name: user.Name,
        'Licensed Organization': user.LicensedOrg,
        'Licensed Organizational Unit': user.LicensedOrgUnit,
        Role: user.SystemRole.DisplayName,
        'Super User': getCheckBoxValue(user.IsSuperUser),
        'Internal ATM': getInternalAtmValue(user),
        'View Invoices': getCheckBoxValue(user.CanAccessInvoices),
        'FDA ATM': getFdaAtmValue(user),

        Observation: OBSERVATION_OPTIONS[appraiserInfo.Observation] ?? null,
        'Direct Channel': DIRECT_CHANNEL_OPTIONS[appraiserInfo.DirectChannel] ?? null,

        'Staff ATM': getStaffAtmValue(user)
      };
    });

    const csvData = convertArrayToCSV(formattedUserList);

    const zip = new JSZip();
    zip.file(`${FILE_NAME}.csv`, csvData);
    const zipBlob = await zip.generateAsync({ type: 'blob' });

    saveAs(zipBlob, `${FILE_NAME}.zip`);
  };

  return (
    <button className='primary-button' onClick={handleDownload}>
      Download Users
    </button>
  );
};
const getCheckBoxValue = value => {
  if (value === null) {
    return null;
  }

  return value ? 'Y' : 'N';
};

const getInternalAtmValue = user => getAtmValue(user, INTERNAL_ROLES);
const getFdaAtmValue = user => getAtmValue(user, FDA_ATM_ROLES);
const getStaffAtmValue = user => getAtmValue(user, STAFF_ATM_ROLES);

const getAtmValue = (user, validRoles) =>
  validRoles.includes(user.SystemRole.Id) ? getIsATM(user.SupplementalRoleId) : null;

const getIsATM = supplementalRoleId => (supplementalRoleId === SUPPLEMENTAL_ROLES.ATM ? 'Y' : 'N');

export default UserListDownloader;
